import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I'm <span className="purple">Mouez Belkahla</span>{" "}
            from <span className="purple">Monastir, Tunisia</span>.
            <br />
            I graduated in 2025 with a degree in{" "}
            <span className="purple">Software Engineering</span> from{" "}
            <span className="purple">ESPRIM</span>, specializing in RESTful
            API design, secure authentication, and relational data modeling
            with <span className="purple">ASP.NET Core</span> and{" "}
            <span className="purple">Spring Boot</span>, paired with{" "}
            <span className="purple">React</span> and{" "}
            <span className="purple">Angular</span> frontends.
            <br />
            I'm passionate about building full-stack applications. For my
            end-of-studies internship (PFE) at{" "}
            <span className="purple">IT Solution</span>, I delivered{" "}
            <span className="purple">ReelState</span>, a social real-estate
            platform with short-form video listings and AI-powered search.
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs ✍️
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places 🌍
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Mouez</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;